const jaJP = {
  '青瓷游戏官方充值中心': 'QCPlayトークンストア',
  '官方充值': 'トークン購入',
  '我的订单': '購入履歴',
  '联系客服': 'お問い合わせ',
  '您好，请登录': 'ログイン',
  '注销': 'ログアウト',
  '最强蜗牛': '最強でんでん',
  '角色名称.游戏区组': 'ログインしてアカウントを選択',
  '代钞': 'トークン',
  '所选商品': '選択商品',
  '含': '内容',
  '赠': 'ボーナス',
  '等待支付结果完成中': '支払い処理中…',
  '请稍后': 'しばらくお待ちください',
  '代钞具体到账情况请到': '購入したトークンはゲーム内',
  '游戏“背包”中进行查看': '「旅行鞄」よりご確認ください',
  '支付查询中': '支払い状況確認中…',
  '合计': '支払金額',
  '充值说明': '注意事項',
  '立即支付': '支払う',
  '青瓷游戏': 'QCPlay',
  '官方充值中心': 'QCPlayトークンストア',
  '角色名称': 'キャラクター名',
  '游戏区组': 'ゲームサーバー',
  '充值账号': '購入対象アカウント',
  '选择游戏区组': 'サーバーを選択',
  '苹果': 'iOS',
  '安卓': 'Android',
  '请选择区组': 'サーバーを選択してください',
  '请选择角色': 'キャラクターを選択してください',
  '取消': 'キャンセル',
  '确定': 'OK',
  '温馨提示': 'ご注意',
  '游戏维护期间，暂时无法为您充值，给您造成的不便敬请谅解': 'ゲームメンテナンス中は購入できません。メンテナンス終了後にご購入ください',
  '好的': 'OK',
  '请选择商品类目': '商品種別を選択してください',
  '请选择区组信息': 'サーバーを選択してください',
  '登录': 'ログイン',
  '请先同意下方《青瓷游戏隐私政策》、《青瓷游戏用户服务协议》': '各規約をお読みの上、ご同意ください',
  '邮箱信息填写错误': 'メールアドレスが正しくありません',
  '登录成功': 'ログインしました',
  '共': '計',
  '条': '件',
  '选择需要充值的游戏': '購入対象のゲームを選択してください',
  '您好，': 'こんにちは！',
  '暂无信息': 'データがありません',
  '请登录': 'ログイン',
  '购买的代劵将反映在以下账号内，请确认内容无误': '以下のアカウントでトークンを購入します。よろしいですか？',
  '支付成功': '支払いが完了しました',
  '代钞具体到账情况请到游戏“背包”中进行查看': 'ゲームにログインし、「旅行鞄」内にてトークンをご確認ください',
  '支付失败': '支払いに失敗しました',
  '请稍后再试': 'しばらく経ってからお試しください',
  '查看订单': '注文履歴確認',
  '网络超时,请刷新页面或稍后重试': '接続がタイムアウトしましたページを更新するか、しばらく経ってから再度お試しください',
  '订单号': '購入番号',
  '下单时间': '購入日時',
  '开始日期': '開始日',
  '至': '～',
  '结束日期': '終了日',
  '没有更多了': 'これで全部です',
  '全部游戏': '全ゲーム',
  '恭喜您复制成功，赶快去粘贴吧': 'コピーしました！',
  '操作失败，请重试！': '操作失敗！再試行してください',
  '遇到问题？': 'ヘルプ',
  '邮箱账号登录': 'QCPlayアカウントでログイン',
  '请输入邮箱': 'メールアドレス',
  '请输入密码': 'パスワード',
  '查看如何拥有邮箱账号': 'QCPlayアカウントの作成とバインド方法',
  '年龄认证': '年齢確認',
  '您的年龄决定了您每月可以购买的可计费项目的数量。': 'あなたの年齢によって1ケ月に購入できる有償アイテムの上限額が決まっています。',
  '请输入正确的出生日期。': '正しい生年月日を入力してください。',
  '设定的出生日期以后不能更改。': '設定した生年月日は後から変更できません',
  '16岁以下': '16歳未満',
  '16岁以上18岁未满': '16歳以上18歳未満',
  '18岁及以上': '18歳以上',
  '1个月': '1ヶ月',
  '无限制': '制限なし',
  '5000元以下': '5000円まで',
  '20000元以下': '20000円まで',
  '年': '年',
  '月': '月',
  '日': '日',
  '元': '円',
  '阅读并同意': '下記規約内容を確認した上で、同意します',
  '《青瓷游戏隐私政策 》': '「プライバシーポリシー」',
  '《青瓷游戏用户服务协议》': '「QCplayアカウント利用規約」',
  '在进行支付时，由于支付渠道相关规则，可能出现超额提醒、限额提醒、风险提醒等，可切换支付方式后再次尝试': '支払いに関連する警告メッセージ等が表示された場合には、決済会社にご相談いただくか、支払い方法の変更をお試しください。',
  '温馨提示：请您知悉，点击立即支付即视为您同意': 'ご注意：ご購入いただく前に、必ず下記の各規約をご確認の上、ご同意ください。',
}

export default jaJP